module.exports = __webpack_public_path__ + "img/menu_4.68c87705.png";